import DataTable from 'datatables.net-dt';
import CartItems from './cartItems';
import selectors from './selectors';
import updateCartCount from './updateCartCount';
import handleLangToggle from './handleLangToggle';
import handleSearchClick from './handleSearchClick';
import handleSearchSubmit from './handleSearchSubmit';
import handleAddResource from './handleAddResource';

const actions = {
	click: {
		resources: 'click.resourcesActions',
		add: 'click.addToCollection',
	},
};
const resourcesCart = {
	/**
	 * This variable will hold the ajax gravity form markup
	 * clicked will be added in the modal form view.
	 *
	 * @type string
	 */
	ajaxFormClone: '',

	/**
	 * Add to cart events and functionality.
	 *
	 * @return void
	 */
	initAddToCollectionBehavior() {
		const { resources } = selectors;
		const { add } = actions.click;

		CartItems.fetch();

		$('body').off(add).on(add, resources.actions.add, handleAddResource);
	},

	/**
	 * Init the data table plugin.
	 *
	 * @return void
	 */
	initDataTables() {
		const table = $(selectors.table.container);
		// eslint-disable-next-line no-unused-vars
		const t = new DataTable(
			table,
			{
				order: [],
				searching: false,
				paging: false,
				bInfo: false,
				columns: [
					{
						orderable: true,
						width: '57%',
					},
					{
						orderable: true,
						width: '16.66%',
					},
					{
						orderable: false,
						width: '12.66%',
					},
					{
						orderable: false,
						width: '13.66%',
					},
				],
			},
		);
	},

	initSearchEvents() {
		const { form } = selectors.search;

		$('body').on('submit', form, handleSearchSubmit);

		window.addEventListener('click', handleSearchClick);
	},

	initResourceLangToggle() {
		const { click } = actions;
		$('body').off(click.resources).on(click.resources, handleLangToggle);
	},

	emptyCart() {
		Object.keys(localStorage)
		.filter(x =>
			x.startsWith('vtc-cart-items'))
		.forEach(x =>
			localStorage.removeItem(x));

		updateCartCount();
	},
};

export default resourcesCart;
